import React, { useRef, useEffect, useState } from 'react';
import { Form, Cascader } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { observer } from 'mobx-react-lite';
import { getTreeEnumByCategory } from '@service/resumeDetail';
import { useRequest } from 'ahooks';
import cloneDeep from 'lodash/cloneDeep';
import ModuleView from '../../ModuleView';
import './index.scss';

const FormItem = Form.Item;

// 仅校招
function Competition(props) {
  const formRefs = useRef<any[]>([]);
  const { data } = props;
  const { campusResumeDetail, campusResumeFormRefStore } = useRootStore();
  const store = campusResumeDetail;
  const storeRef = campusResumeFormRefStore;
  const [competitionEnum, setCompetitionEnum] = useState<any[]>([]);

  // 获取竞赛枚举
  useRequest(() => getTreeEnumByCategory({ category: 'competition' }), {
    onSuccess: (res) => {
      const tmp = res?.map((item) => {
        let children;
        if (item?.children?.length > 0) {
          children = item.children.map((subItem) => {
            return { value: subItem.id, label: subItem.name };
          });
        }

        return { value: item.id, label: item.name, children };
      });
      setCompetitionEnum(tmp);
    },
  });

  /**
   * 初始化
   */
  useEffect(() => {
    storeRef.changeRef('resumeCompetitionListRef', formRefs.current);
    const cloneData = cloneDeep(data);
    cloneData?.map((item, index) => {
      item.competition = item?.competitionCode ? [item?.competitionCode, item?.awardCode] : [];
      formRefs.current[index]?.setFieldsValue(item);
      return null;
    });
  }, [data, data?.length]);

  /**
   * 修改表单值同步更新store的值
   */
  const handleChange = (index, formItemKey, formItemValue) => {
    const competitionName = competitionEnum?.find((item) => item?.value === formItemValue?.[0]);
    const awardName = competitionName?.children?.find((item) => item?.value === formItemValue?.[1]);
    store.setResumeCompetitionList(index, 'competitionCode', formItemValue?.[0]);
    store.setResumeCompetitionList(index, 'competitionName', competitionName?.label);
    store.setResumeCompetitionList(index, 'awardCode', formItemValue?.[1]);
    store.setResumeCompetitionList(index, 'awardName', awardName?.label);
  };

  return (
    <div className="competition_edit model_edit">
      <div className="model_title">竞赛</div>
      {data?.map((item, index) => (
        <div className="model_list" key={item.renderId}>
          <Form
            ref={(el) => {
              formRefs.current[index] = el;
            }}
            className="modal_form"
            onFieldValueChange={(formItemKey, formItemValue) => handleChange(index, formItemKey, formItemValue)}
          >
            <FormItem span="11" formItemKey="competition" labelWidth={0} required message="请填写获奖大赛">
              <div className="label">
                获奖大赛<span className="icon">*</span>
              </div>
              <Cascader
                toFormItem
                expandTrigger="hover"
                size="large"
                data={competitionEnum}
                // onChange={(value, selectedOptions) => {
                //   handleChange(value, selectedOptions, index);
                // }}
                popLayer={{ className: 'competition_cascader' }}
              />
            </FormItem>
          </Form>
          <div className="delete-list">
            <div onClick={() => store.deleteResumeList('resumeCompetitionList', index)}>删除这段信息</div>
          </div>
        </div>
      ))}
      <div
        className="list_add"
        onClick={() => {
          store.addResumeList('resumeCompetitionList');
        }}
      >
        <div className="add_icon">
          <img src={require('@imgs/add.svg')} alt="" />
        </div>
        添加竞赛
      </div>
    </div>
  );
}

export default ModuleView(observer(Competition), 'competition');
